import { UIComponentImpl, UIDataModel, UIComponentState, UIComponentHandler } from '../../../toolkit/uicomponent';
import { BaseContext } from '../../../../utils/basecontext';
import { UIComponentView } from '../../../toolkit/uicomponentview';
import { CRBTUIViewImpl } from './crbtuiview';
import { UIComponentCSSStyle } from '../../../toolkit/uicomponentcss';
import { CRBTUICSSStyleImpl } from './crbtuicss';
import { ChildComponentProps } from '../../mainwrappercomponent';


export interface CRBTUIComponentProps extends ChildComponentProps
{
    isBannerRequired: boolean;
    isNavigationPathRequired: boolean;
}

export class CRBTUIComponent<T extends CRBTUIComponentProps, S extends UIComponentState> extends UIComponentImpl<T, S, UIDataModel>
{
    componentDidMount()
    {
        console.log("CRBTUI componentDidMount() invoked");
        window.scrollTo(0,0);
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new CRBTUIViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new CRBTUICSSStyleImpl(applicationContext);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/crbt/crbtuicomponent.tsx